// src/pages/forum/ForumReplyList.jsx

import React from "react";
import ForumReplyItem from "./ForumReplyItem";
import { useTranslation } from "react-i18next";
export default function ForumReplyList({
    replies = [],
    loading = false,
    currentUser,
    onLike,
    onEdit,
    onDelete

}) {
 const { t } = useTranslation();
    //----------------------------------------------------------
    // Chargement
    //----------------------------------------------------------

    if (loading) {

        return (

            <div className="text-center py-5">
                <div
                    className="spinner-border text-success"
                    role="status"
                >
                    <span className="visually-hidden">
                        Chargement...
                    </span>
                </div>

                <h5 className="mt-3 text-muted">
                    Chargement des réponses...
                </h5>

            </div>

        );

    }

    //----------------------------------------------------------
    // Aucune réponse
    //----------------------------------------------------------

    if (!replies || replies.length === 0) {

        return (
            <div className="card shadow-sm border-0">
                <div className="card-body text-center py-5">
                    <i className="bi bi-chat-left display-1 text-success"></i>
                    <h4 className="mt-4">
                        {t("forum.noReplies")}
                    </h4>
                    <p className="text-muted">
                        {t("forum.beFirstToReply")}

                    </p>
                </div>
            </div>
        );
    }

    //----------------------------------------------------------

    return (

        <div className="forum-reply-list">

            <div className="mb-3">

                <h5 className="fw-bold text-success">

                    <i className="bi bi-chat-dots-fill me-2"></i>

                    {t("forum.replies")} ({replies.length})

                </h5>

            </div>

            {

                replies.map((reply, index) => (

                    <ForumReplyItem
                        key={reply.id ?? index}
                        index={index + 1}
                        reply={reply}
                        currentUser={currentUser}
                        onLike={onLike}
                        onEdit={onEdit}
                        onDelete={onDelete}
                    />
                ))
            }
        </div>
    );

}